import { render } from "./Defs.vue?vue&type=template&id=161750b4"
import script from "./Defs.vue?vue&type=script&lang=js"
export * from "./Defs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__